import { Theme, SxProps } from '@mui/material';
import { ISxProps } from '../../../../../resource';

// Import table styles from V1
import tableStyles from '../../../../ManageWidgets/components/Widget/components/Table/styles';

// Dialog styles matching V1
export const dialogStyles: ISxProps<Theme> = (theme: Theme) => ({
  position: 'relative',
  backgroundColor: theme.palette.common.white,
  p: theme.spacing(10, 16),
  borderRadius: theme.spacing(30, 0),
  display: 'flex',
  flexDirection: 'column',
} as const);

// Column settings dialog styles
export const columnSettingsDialogStyles: ISxProps<Theme> = (theme: Theme) => ({
  position: 'relative',
  backgroundColor: 'white',
  p: theme.spacing(98, 20, 40, 20),
  maxWidth: { xs: 560, md: 560 },
  width: 1,
  borderRadius: theme.spacing(30, 0),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const);

// Drag indicator styles
export const dragIndicatorStyles: SxProps<Theme> = {
  cursor: 'grab',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px',
  '&:active': {
    cursor: 'grabbing',
  },
};

// Config wrapper styles
export const configWrapperStyles: SxProps<Theme> = {
  display: 'flex',
  gap: '2px',
};

// Config field styles
export const configFieldStyles = (theme: Theme, type: 'text' | 'table' | 'html'): SxProps<Theme> => ({
  fontSize: '12px',
  width: 'fit-content',
  color: theme.palette.text.primary,
  backgroundColor: type === 'text' ? theme.palette.grey['200'] : theme.palette.success['light'],
  padding: theme.spacing(4, 8),
  borderRadius: theme.spacing(8),
  cursor: 'pointer',
  border: '1px solid transparent',
});

// Export table styles from V1
export { default as tableStyles } from '../../../../ManageWidgets/components/Widget/components/Table/styles';

